<template>
    <div class="course-video">
        <div class="course-video__movie" id="embed">
            <JWPlayerVideo
                v-if="shouldInitializePlayer && isJW && !forceNoVideo"
                v-on:demoFinished="onDemoFinished"
                v-on:progress="onProgress"
                v-on:persistPlayedTime="onPersistPlayedTime"
                v-on:saveVideoLog="onSaveVideoLog"
                v-on:invalidVideoUrl="onInvalidVideoUrl"
                v-on:restoreFromHiddenCourses="onRestoreFromHiddenCourses"
                v-on:reInitializeVideo="reInitializeVideo"
            />
            <VimeoVideo
                v-if="shouldInitializePlayer && isVimeo && !forceNoVideo"
                v-on:demoFinished="onDemoFinished"
                v-on:progress="onProgress"
                v-on:persistPlayedTime="onPersistPlayedTime"
                v-on:saveVideoLog="onSaveVideoLog"
                v-on:restoreFromHiddenCourses="onRestoreFromHiddenCourses"
                v-on:reInitializeVideo="reInitializeVideo"
                v-on:videoWasPlayed="videoWasPlayed = true"
            />
            <NoVideo v-if="!shouldInitializePlayer || forceNoVideo"/>
        </div>
    </div>
</template>
<script>
    import JWPlayerVideo from 'components/coursepage/coursevideo/JWPlayerVideo'
    import VimeoVideo from 'components/coursepage/coursevideo/VimeoVideo'
    import NoVideo from 'components/coursepage/coursevideo/NoVideo'
    import { mapGetters } from 'vuex'

    export default {
        components: {
            NoVideo,
            VimeoVideo,
            JWPlayerVideo,
        },
        props: {
            isFree: Boolean,
            isLoggedIn: Boolean,
            courseId: Number
        },
        computed: {
            ...mapGetters({
                shouldInitializePlayer: 'VideoPlayer/shouldInitializePlayer',
                isVimeo: 'VideoPlayer/isVimeo',
                isJW: 'VideoPlayer/isJW',
                isMicroLearningCourse: 'MicroLearning/isMicroLearningCourse',
                userId: 'getUserId',
                microLearningVideoLogs: 'MicroLearning/getMicroLearningVideoLogs',
                allCurrentlyWatchedSequences: 'VideoPlayer/allWatchedSequences'
            })
        },
        data () {
            return {
                forceNoVideo: false,
                videoWasPlayed: false
            }
        },
        methods: {
            onDemoFinished () {
                this.$modal.show('shown-after-demo-watched')
            },
            onProgress (eventData) {
                this.$store.dispatch('VideoPlayer/progressVideo', eventData)
                if (this.isMicroLearningCourse) {
                    this.$store.dispatch('MicroLearning/microLearningVideoProgress', eventData)
                }
            },
            onPersistPlayedTime (eventData) {
                if (this.isFree && !this.isLoggedIn) {
                    return
                }
                this.$store.dispatch('VideoPlayer/persistPlays')
            },
            onSaveVideoLog () {
                if (!this.videoWasPlayed || !this.isLoggedIn) {
                    return
                }
                this.$store.dispatch('VideoPlayer/sendVideoLogToAesir')
            },
            onRestoreFromHiddenCourses () {
                if (this.isLoggedIn) {
                    this.$store.dispatch('User/hideOrRestoreUncompletedCourseFromList', {
                        courseId: this.courseId,
                        isHidden: false
                    })
                }
            },
            onInvalidVideoUrl () {
                this.forceNoVideo = true
            },
            reInitializeVideo () {
                this.$emit('reInitializeVideo')
            }
        },
        beforeDestroy () {
            const shouldSaveVideoLogs = this.videoWasPlayed && (
                (this.isMicroLearningCourse && this.microLearningVideoLogs) || this.allCurrentlyWatchedSequences
            )
            if (shouldSaveVideoLogs) {
                this.onSaveVideoLog()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .course-video {
        margin: 20px 0 20px;
        position: relative;

        &__movie {
            position: relative;
            padding-bottom: 56.25%;
            height: 0;
            overflow: hidden;
            max-width: 100%;

            iframe,
            object,
            embed,
            img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }
    }
</style>
